const utils = require('../../utils')
import { mapGetters } from 'vuex'

import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'propose-edit',
  created () {
    this.search()
    this.joinUsersSearch()
    this.profileSearch()
  },
  data () {
    return {
      callbackflg: false,
      searchCallbackFlag: false,
      profileCallbackFlag: false,
      searchUserName: null,
      focus: false,
      joint1UserId: null,
      joint2UserId: null,
      proposeTitle: null,
      proposeContent: null,
      ideaPeaceMing: null,
      ideaSincere: null,
      ideaExcitement: null,
      ideaComfortable: null,
      ideaCreation: null,
      ideaCivility: null,
      ideaImagination: null,
      ideaSympathy: null,
      ideaExpression: null,
      ideaChallengeDream: null,
      jointUsers: [],
      proposeImages: [],
      proposeBase64Images: [],
      upFlg: false
    }
  },
  computed: {
    ...mapGetters({
      proposeDetail: 'editProposeDetail',
      joint1User: 'editJoint1User',
      joint2User: 'joint2User',
      joinUsers: 'joinUsers',
      profileDetail: 'profileDetail',
      profile: 'profileDetail'
    }),
    getUserFullName () {
      return window.localStorage.getItem('user_name')
    },
    profileImagePath () {
      return window.localStorage.getItem('profile_image_path') ? window.localStorage.getItem('profile_image_path') : ''
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()
      const hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      const min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      const sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    uploadError () {
      return this.$store.getters.proposeUploadError
    }
  },
  methods: {
    search: function () {
      const self = this
      const data = {}
      const callback = function () {
        self.callbackflg = true
        self.proposeTitle = self.proposeDetail.attributes['propose-title']
        self.proposeContent = self.proposeDetail.attributes['propose-content']
        self.ideaPeaceMing = self.proposeDetail.attributes['idea-peace-ming'] === 1 ? 1 : null
        self.ideaSincere = self.proposeDetail.attributes['idea-sincere'] === 1 ? 1 : null
        self.ideaExcitement = self.proposeDetail.attributes['idea-excitement'] === 1 ? 1 : null
        self.ideaComfortable = self.proposeDetail.attributes['idea-comfortable'] === 1 ? 1 : null
        self.ideaCreation = self.proposeDetail.attributes['idea-creation'] === 1 ? 1 : null
        self.ideaCivility = self.proposeDetail.attributes['idea-civility'] === 1 ? 1 : null
        self.ideaImagination = self.proposeDetail.attributes['idea-imagination'] === 1 ? 1 : null
        self.ideaSympathy = self.proposeDetail.attributes['idea-sympathy'] === 1 ? 1 : null
        self.ideaExpression = self.proposeDetail.attributes['idea-expression'] === 1 ? 1 : null
        self.ideaChallengeDream = self.proposeDetail.attributes['idea-challenge-dream'] === 1 ? 1 : null
        self.jointUsers = []
        if (self.joint1User) {
          self.joint1UserId = self.joint1User.id
          self.addJoin(self.joint1User)
        }
        if (self.joint2User) {
          self.joint2UserId = self.joint2User.id
          self.addJoin(self.joint2User)
        }
        self.proposeImages = []
        self.proposeBase64Images = []
        if (self.proposeDetail.attributes['propose-1-image-path']) {
          const images = {
            'propose_image_path': self.proposeDetail.attributes['propose-1-image-path']
          }
          const index = 0
          self.proposeImages.splice(index, 0, images)
          self.loadProposeImage(self.proposeDetail.attributes['propose-1-image-path'], index)
        }
        if (self.proposeDetail.attributes['propose-2-image-path']) {
          const images = {
            'propose_image_path': self.proposeDetail.attributes['propose-2-image-path']
          }
          const index = 1
          self.proposeImages.splice(index, 0, images)
          self.loadProposeImage(self.proposeDetail.attributes['propose-2-image-path'], index)
        }
        if (self.proposeDetail.attributes['propose-3-image-path']) {
          const images = {
            'propose_image_path': self.proposeDetail.attributes['propose-3-image-path']
          }
          const index = 2
          self.proposeImages.splice(index, 0, images)
          self.loadProposeImage(self.proposeDetail.attributes['propose-3-image-path'], index)
        }
      }
      this.$store.dispatch('PROPOSE_EDIT', {id: this.$route.params.id, data: data, callback: callback})
    },
    joinUsersSearch: function () {
      this.searchCallbackFlag = false
      if (!this.searchUserName) return
      const self = this
      const callback = function () {
        if (self.searchUserName) {
          self.focusGet()
          for (let i = self.joinUsers.length - 1; i >= 0; i--) {
            if ((self.joinUsers[i].id === window.localStorage.getItem('user_id')) ||
                (self.jointUsers[0] && self.joinUsers[i].id === self.jointUsers[0]['user_id']) ||
                (self.jointUsers[1] && self.joinUsers[i].id === self.jointUsers[1]['user_id'])) {
              self.joinUsers.splice(i, 1)
            }
          }
        }
        self.searchCallbackFlag = true
      }
      const data = {
        'user_name': this.searchUserName
      }
      this.$store.dispatch('JOIN_USER_SEARCH', {data: data, callback: callback})
    },
    profileSearch: function () {
      const self = this
      const data = {}
      const callback = function () {
        self.profileCallbackFlag = true
      }
      this.$store.dispatch('PROFILE_DETAIL', {id: window.localStorage.getItem('user_id'), data: data, callback: callback})
    },
    changeIdea: function (idea) {
      if (eval('this.' + idea)) {
        eval('this.' + idea + '= null')
      } else {
        eval('this.' + idea + '= 1')
      }
    },
    ideaClass: function (idea) {
      if (eval('this.' + idea)) {
        return '-on'
      } else {
        return ''
      }
    },
    focusGet: function () {
      this.focus = true
    },
    focusOut: function () {
      this.focus = false
    },
    searchOpen: function () {
      if (this.focus) {
        return '-show'
      } else {
        return ''
      }
    },
    padding: function () {
      if (this.focus) {
        return 'padding-bottom: 300px;'
      } else {
        return 'padding-bottom: 24px;'
      }
    },
    notInput: function () {
      if (this.proposeTitle && this.proposeContent && this.isInputedIdeas()) {
        return false
      } else {
        return true
      }
    },
    isInputedIdeas: function () {
      if (this.ideaPeaceMing ||
          this.ideaSincere ||
          this.ideaExcitement ||
          this.ideaComfortable ||
          this.ideaCreation ||
          this.ideaCivility ||
          this.ideaImagination ||
          this.ideaSympathy ||
          this.ideaExpression ||
          this.ideaChallengeDream) {
        return true
      } else {
        return false
      }
    },
    addJoin: function (data) {
      const joins = {
        'user_id': data.id,
        'shop_name': data.attributes['shop-name'],
        'user_type_name': data.attributes['user-type-name'],
        'user_name': data.attributes['user-name'],
        'user_firstname': data.attributes['user-firstname'],
        'profile_image_path': data.attributes['profile-image-path']
      }
      this.jointUsers.push(joins)
      this.focusOut()
    },
    deleteJoin: function (index) {
      this.jointUsers.splice(index, 1)
    },
    onFileDummyClick: function (event) {
      document.getElementById('file').click()
    },
    onFileChange: function (event) {
      console.log('onFileChange')
      const files = event.target.files || event.dataTransfer.files
      this.upload(files[0])
    },
    loadProposeImage: function (proposeImagePath, index) {
      const url = proposeImagePath + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      const self = this
      const request = new XMLHttpRequest()
      request.open('GET', url, true)
      request.responseType = 'blob'
      request.onload = function () {
        const reader = new FileReader()
        reader.readAsDataURL(request.response)
        reader.onload = function (e) {
          const proposeBase64Images = {
            'propose_base64_image_path': e.target.result
          }
          self.proposeBase64Images.splice(index, 0, proposeBase64Images)
        }
      }
      request.send()
    },
    upload: function (file) {
      this.upFlg = true
      const reader = new FileReader()
      const self = this
      reader.onload = (e) => {
        const proposeBase64Images = {
          'propose_base64_image_path': e.target.result
        }
        self.proposeBase64Images.push(proposeBase64Images)
        const formData = new FormData()
        formData.append('propose_image', file)
        self.$store.dispatch('PROPOSE_IMAGE_UPLOAD', { data: formData, callback: self.onUpload, errorCallback: self.notUpload })
      }
      reader.readAsDataURL(file)
    },
    onUpload: function (data) {
      const images = {
        'propose_image_path': data.image_path
      }
      this.proposeImages.push(images)
      this.uploadFlg = true
    },
    notUpload: function () {
      this.proposeBase64Images.pop()
    },
    deleteProposeImage: function (index) {
      this.proposeImages.splice(index, 1)
      this.proposeBase64Images.splice(index, 1)
    },
    onClickSave: function () {
      let propose1Image = null
      let propose2Image = null
      let propose3Image = null
      for (let i = 0; i < this.proposeBase64Images.length; i++) {
        if (i === 0) {
          propose1Image = this.proposeBase64Images[0]['propose_base64_image_path']
        } else if (i === 1) {
          propose2Image = this.proposeBase64Images[1]['propose_base64_image_path']
        } else if (i === 2) {
          propose3Image = this.proposeBase64Images[2]['propose_base64_image_path']
        }
      }
      this.joint1UserId = null
      this.joint2UserId = null
      for (let j = 0; j < this.jointUsers.length; j++) {
        if (j === 0) {
          this.joint1UserId = this.jointUsers[0]['user_id']
        } else if (j === 1) {
          this.joint2UserId = this.jointUsers[1]['user_id']
        }
      }
      const data = {
        user_id: window.localStorage.getItem('user_id'),
        shop_id: window.localStorage.getItem('shop_id'),
        joint_1_user_id: this.joint1UserId,
        joint_2_user_id: this.joint2UserId,
        propose_title: this.proposeTitle,
        propose_content: this.proposeContent,
        propose_1_image: propose1Image,
        propose_2_image: propose2Image,
        propose_3_image: propose3Image,
        idea_peace_ming: this.ideaPeaceMing,
        idea_sincere: this.ideaSincere,
        idea_excitement: this.ideaExcitement,
        idea_comfortable: this.ideaComfortable,
        idea_creation: this.ideaCreation,
        idea_civility: this.ideaCivility,
        idea_imagination: this.ideaImagination,
        idea_sympathy: this.ideaSympathy,
        idea_expression: this.ideaExpression,
        idea_challenge_dream: this.ideaChallengeDream,
        asovi_access_token: window.localStorage.getItem('access_token')
      }
      this.openLoadingModal() // ローディングオープン
      this.$store.dispatch('PROPOSE_UPDATE', { id: this.proposeDetail.id, data: data, callback: this.onSaved })
    },
    openLoadingModal: function () {
      const button = document.getElementById('loadingModalButton')
      button.click() // モーダル表示 イベント発火
    },
    closeLoadingModal: function () {
      $('#loadingModal').modal('hide')
    },
    onSaved: function () {
      this.closeLoadingModal() // ローディングクローズ
      const button = document.getElementById('proposeModalButton')
      button.click() // モーダル表示 イベント発火
    },
    goProposeList: function () {
      this.$router.push('/propose_myshop_list')
    },
    proposeHelp: function () {
      const button = document.getElementById('proposeHelpModalButton')
      button.click() // モーダル表示 イベント発火
    },
    rmEmoji: function (text, data) {
      if (data === 'title') {
        this.proposeTitle = utils.removeEmoji(text)
      } else if (data === 'content') {
        this.proposeContent = utils.removeEmoji(text)
      } else if (data === 'name') {
        this.searchUserName = utils.removeEmoji(text)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-edit.js